import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { Manuscript } from '../../../models/manuscript';
import { MssListFilters } from '../../../models/mss-list-filters';
import { VocsService } from '../../../services/vocs.service';
import { VocTerms, VocTerm } from '../../../models/voc-term';
import { DateRange, DateCalendar } from '../../../models/date-range';
import { NameElement } from '../../../models/name-list';
import { MsWorkList } from '../../../models/ms-work';
import { MsHistoryCopyList } from '../../../models/ms-history-copy';
import { MsHistoryCopyCopyist } from '../../../models/ms-history-copy-copyist';
import { MsBiblioLinkList } from '../../../models/ms-biblio-link';
import { MsImageFile } from '../../../models/ms-image-file';
import { VocTermByIdPipe } from '../../../pipes/voc-term-by-id.pipe';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-ms-details-description',
  templateUrl: './ms-details-description.component.html',
  styleUrls: ['./ms-details-description.component.css']
})
export class MsDetailsDescriptionComponent implements OnInit, OnDestroy {
    private subscriptions: Array<ISubscription> = [];
    manuscript: Manuscript; // current manuscript data
    mssListFilters: MssListFilters; // current active manuscripts filters
    works: MsWorkList; // current manuscript works
    historyCopies: MsHistoryCopyList; // current manuscript history copies
    biblioLinks: MsBiblioLinkList; // current manuscript bibliographic links
    imageFileForRights: MsImageFile;
    countriesVoc: VocTerms;
    citiesVoc: VocTerms;
    librariesVoc: VocTerms;
    placesVoc: VocTerms; // vocabulary of places
    biblioTypesVoc: VocTerms; // vocabulary of biliographic types
    biblioRespTypesVoc: VocTerms; // vocabulary of biliographic responsability types

    constructor(
        private router: Router,
        private manuscriptsService: ManuscriptsService,
        private vocsService: VocsService,
        private vocTermByIdPipe: VocTermByIdPipe
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.manuscriptsService.getMssListFilters()
                .subscribe(response => this.mssListFilters = response, err => console.error(err)),
            this.manuscriptsService.getManuscript()
                .subscribe(response => this.manuscript = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptWorks()
                .subscribe(response => this.works = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptHistoryCopies()
                .subscribe(response => this.historyCopies = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptBiblioLinks()
                .subscribe(response => this.biblioLinks = response, err => console.error(err)),
            this.manuscriptsService.getManuscriptImageFiles()
                .subscribe(response => {
                    this.imageFileForRights = response.find(imgFile => imgFile.quotation_label.length > 0);
                }, err => console.error(err)),
            this.vocsService.getCountries().subscribe(response => this.countriesVoc = response, err => console.error(err)),
            this.vocsService.getCities().subscribe(response => this.citiesVoc = response, err => console.error(err)),
            this.vocsService.getLibraries().subscribe(response => this.librariesVoc = response, err => console.error(err)),
            this.vocsService.getMsCopyPlaces().subscribe(response => this.placesVoc = response, err => console.error(err)),
            this.vocsService.getBiblioTypes().subscribe(response => this.biblioTypesVoc = response, err => console.error(err)),
            this.vocsService.getBiblioRespTypes().subscribe(response => this.biblioRespTypesVoc = response, err => console.error(err))
        );
    }

    searchMssByCountry(vocTermId: number): void {
        this.mssListFilters.reset();
        this.mssListFilters.country = <VocTerm> this.vocTermByIdPipe.transform(this.countriesVoc, vocTermId, false, true);
        this.manuscriptsService.updateFilters(this.mssListFilters);
        this.router.navigate(['/manuscripts/list']);
    }

    searchMssByCity(vocTermId: number): void {
        this.mssListFilters.reset();
        this.mssListFilters.city = <VocTerm> this.vocTermByIdPipe.transform(this.citiesVoc, vocTermId, false, true);
        this.manuscriptsService.updateFilters(this.mssListFilters);
        this.router.navigate(['/manuscripts/list']);
    }

    searchMssByLibrary(vocTermId: number): void {
        this.mssListFilters.reset();
        this.mssListFilters.library = <VocTerm> this.vocTermByIdPipe.transform(this.librariesVoc, vocTermId, false, true);
        this.manuscriptsService.updateFilters(this.mssListFilters);
        this.router.navigate(['/manuscripts/list']);
    }

    searchMssByCopyDate(copyDateFrom: number, copyDateTo: number): void {
        this.mssListFilters.reset();
        this.mssListFilters.copyDate = <DateRange> {
            from: copyDateFrom,
            to: copyDateTo,
            calendar: DateCalendar.Islamic
        };
        this.manuscriptsService.updateFilters(this.mssListFilters);
        this.router.navigate(['/manuscripts/list']);
    }

    searchMssByCopyist(copyist: MsHistoryCopyCopyist): void {
        this.mssListFilters.reset();
        this.mssListFilters.copyist = <NameElement> {
            name: copyist.name,
            name_laqab: copyist.name_laqab,
            name_kunya: copyist.name_kunya,
            name_ism: copyist.name_ism,
            name_nasab: copyist.name_nasab,
            name_nisba: copyist.name_nisba
        };
        this.manuscriptsService.updateFilters(this.mssListFilters);
        this.router.navigate(['/manuscripts/list']);
    }

    searchMssByCopyPlace(vocTermId: number): void {
        this.mssListFilters.reset();
        this.mssListFilters.copyPlace = <VocTerm> this.vocTermByIdPipe.transform(this.placesVoc, vocTermId, false, true);
        this.manuscriptsService.updateFilters(this.mssListFilters);
        this.router.navigate(['/manuscripts/list']);
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/ui/ms-details-description/ms-details-description.component.ts